module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password custom-left-align"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("\n          Your invitation is either expired or was already used\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n          The invitation link you used is not working. This may happen because:\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.topLoginForm.email !== '' || _vm.topLoginForm.emailFocus,
      'has-error': _vm.topLoginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.email),
      expression: "topLoginForm.email"
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.topLoginForm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topLoginForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus,
      'has-error': _vm.topLoginForm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('top')
      }
    }
  }), _vm._v(" "), ((_vm.topLoginForm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    attrs: {
      "id": "landing-page-login-password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.topLoginForm.password) ? _vm._i(_vm.topLoginForm.password, null) > -1 : (_vm.topLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.topLoginForm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.topLoginForm, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.topLoginForm, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.topLoginForm, "password", $$c)
        }
      }
    }
  }) : ((_vm.topLoginForm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    attrs: {
      "id": "landing-page-login-password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.topLoginForm.password, null)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.topLoginForm, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    attrs: {
      "id": "landing-page-login-password",
      "type": _vm.topLoginForm.passwordType
    },
    domProps: {
      "value": (_vm.topLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topLoginForm, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.topLoginForm.isError) ? _c('div', {
    staticClass: "login-form-error"
  }, [_vm._v("\n            " + _vm._s(_vm.topLoginForm.loginErrorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions custom-left-align-actions"
  }, [_c('router-link', {
    staticClass: "reset-password",
    attrs: {
      "to": {
        name: 'forgot-password'
      }
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.topLoginForm.loginInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authenticate('top')
      }
    }
  }, [_vm._v("Login")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n          Having trouble accessing your account? "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Get in touch")]), _vm._v(" and tell us about your problem, we’ll do our best to help you.\n        ")], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("\n            Your invitation was sent more than 30 days ago or your invitation was revoked. In this case, please ask the person who invited you to do it again.\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            You may have already activated your account.If so, please check your invitation email for the temporary\n            credentials we sent you and try to login using the form below. Otherwise, please contact support.team@clearassured.co.uk\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f14cdc0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/ExpiredAccountToken.vue
// module id = 957
// module chunks = 1